import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpService } from '@services/http.service';

export type SensorPropertiesResponse = {
  sensorType: number;
  values: Record<string, string>;
};

@Injectable({ providedIn: 'root' })
export class SensorPropertiesService extends HttpService {
  private readonly API = `${environment.apiUrl}/devices/sensors`;

  getProperties(deviceSensorId: string): Observable<SensorPropertiesResponse> {
    const options = this.createHeaders();
    return this.get(`${this.API}/${deviceSensorId}/properties`, options);
  }

  upsertProperties(deviceSensorId: string, values: Record<string, any>): Observable<void> {
    const options = this.createHeaders();
    return this.put(`${this.API}/${deviceSensorId}/properties`, { values }, options);
  }

  deleteProperties(deviceSensorId: string): Observable<void> {
    const options = this.createHeaders();
    return this.deleteRaw(`${this.API}/${deviceSensorId}/properties`, options);
  }
}